<template>
  <div>
    <Header :active="1"></Header>
    <Render1></Render1>
    <Render2></Render2>
    <Render3></Render3>
    <Position></Position>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../components/Header/index'
import Render1 from '../components/render/render1'
import Render2 from '../components/render/render2'
import Render3 from '../components/render/render3'
import Position from '../components/Position/index'
import Footer from '../components/Footer/index'
export default {
  components: {
    Header,
    Render1,
    Render2,
    Render3,
    Position,
    Footer,
  },
  data() {
    return {
      
    }
  },
}
</script>